var React = require('react');

function IconGlossary (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M0 2.438C0 1.54.729.812 1.625.812h9.75c.896 0 1.625.73 1.625 1.625v8.126c0 .896-.729 1.624-1.625 1.624h-9.75A1.626 1.626 0 0 1 0 10.563V2.437Zm6.5 0v8.124h4.875V2.438H6.5Z"}));
}

IconGlossary.defaultProps = {"fill":"none","viewBox":"0 0 13 13"};

module.exports = IconGlossary;

IconGlossary.default = IconGlossary;
